import { Injectable, isDevMode } from '@angular/core';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Globals } from '../globals';

export interface ISftpFileCount {
  name: string;
  count: number;
}

/**
 * SFTP Data Crypto Service
 *
 * Účel třídy:
 * - Spravuje data o FTP providerech a jejich stavu
 * - Poskytuje centralizovaný přístup k SFTP datům přes BehaviorSubject
 * - Ukládá data do localStorage pro perzistenci mezi session
 * - Zajišťuje real-time aktualizace přes WebSocket
 *
 * Co dělá:
 * - Inicializuje BehaviorSubject s prázdným polem
 * - Automaticky načte data z localStorage při konstrukci
 * - Poskytuje metody pro update dat z WebSocket
 * - Loguje data v development módu
 *
 * Kdy se volá:
 * - Při konstrukci service (singleton)
 * - Při příchozích WebSocket zprávách (updateData)
 * - Při inicializaci komponent, které se přihlásí k sftpData
 * - Automaticky při startu aplikace (loadInitialData)
 *
 * Data flow:
 * 1. Service se vytvoří jako singleton
 * 2. Automaticky načte data z localStorage
 * 3. Komponenty se přihlásí k BehaviorSubject
 * 4. WebSocket aktualizuje data přes updateData
 * 5. Všechny komponenty dostanou notifikaci o změně
 *
 * Použití:
 * - Injectovat do komponent, které potřebují SFTP data
 * - Přihlásit se k sftpData BehaviorSubject
 * - Volat updateData při příchozích WebSocket zprávách
 */
// https://www.joshmorony.com/using-behaviorsubject-to-handle-asynchronous-loading-in-ionic/
@Injectable()
export class SftpDataCryptoService {
  public sftpData: BehaviorSubject<ISftpFileCount[]> = new BehaviorSubject<ISftpFileCount[]>([]);

  constructor(private globals: Globals) {
    // Load initial data from localStorage if available
    this.loadInitialData();
  }

  updateData(data: ISftpFileCount[]): void {
    if (isDevMode()) {
      console.log('SFTP (update) Data=' + JSON.stringify(data));
    }
    localStorage.setItem('sftpData', JSON.stringify(data));
    this.sftpData.next(data);
  }

  private loadInitialData(): void {
    const data = localStorage.getItem('sftpData');
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        // if (isDevMode()) {
          console.log('SFTP (initial load) Data=' + JSON.stringify(parsedData));
        // }
        this.sftpData.next(parsedData);
      } catch (error) {
        // if (isDevMode()) {
          console.log('SFTP (initial load) Error parsing data:', error);
        // }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/service-crypto/sftp-data-crypto.service.ts